module.exports = __webpack_public_path__ + "img/zhkq2.3944f81a.png";